import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Error404 from "./components/Error404/Error404";
import Scii from "./components/SCII/Scii";
import Calidad from "./components/Calidad/Calidad.js";

import SalaDePrensa from "./components/SalaDePrensaPrensa/SalaDePrensaPrensa";
import Convocatorias from "./components/Convocatorias/Convocatorias.js";
import Organigrama from "./components/Organigrama/Organigrama";
import Directoriomodulos from "./components/Directoriomodulos/Directoriomodulos";
import ArmonizacionContable from "./components/ArmonizacionContable/ArmonizacionContable";
import Elementos from "./components/Elementos/Elementos";
import GuestValidationChecklist from "./components/GuestValidationChecklist.js";
import Curso from "./components/Curso/Curso";
import Paas from "./components/PAAS/Paas";
import MIR from "./components/MIR.js";
import Tramites from "./components/Tramites.js";
import Menu from "./components/MenuDesplegable/Menu";
import CalendariosAutorizados from "./components/CalendariosAutorizados/CalendariosAutorizados.js";


function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Directoriomodulos" element={ <Directoriomodulos/> } />
          <Route exact path="/Scii" element={ <Scii/> } />
                    <Route exact path="/Calidad" element={ <Calidad/> } />

          <Route exact path="/Elementos" element={ <Elementos/> } />
          <Route exact path="/Curso" element={ <Curso/> } />
          <Route exact path="/Armonizacion" element={ <ArmonizacionContable/> } />
          <Route exact path="/Tramites" element={ <Tramites/> } />
          <Route exact path="/Organigrama" element={ <Organigrama/> } />
          <Route exact path="/GuestValidationChecklist" element={ <GuestValidationChecklist/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/PAAS" element={ <Paas/> } />
         <Route exact path="/Transparencia/MIR" element={ <MIR/> } />
          <Route exact path="/Transparencia/CalendariosAutorizados" element={ <CalendariosAutorizados/> } />


          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="/PublicaciondeResultados" element={ <Convocatorias/> } />
          <Route exact path="/SaladePrensa" element={ <SalaDePrensa/> } />
          <Route exact path="/Menu" element={ <Menu/> } />
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
